import ScrollMagic from 'ScrollMagic';
import '../animation.gsap';
import '../MorphSVGPlugin';

import initializr from '../initializr';
import NavModal from '../modules/nav_modal';
import videoReplace from '../modules/video_replace';
import { subtleMouseMove, b2bImageMaskAnimation } from '../modules/animations';
import canvasAnimation from '../modules/animations/canvasAnimation';
import { Point } from '../modules/animations/helpers';

initializr({
  common: {
    initialize: () => {
      new NavModal();

      const overlay = document.querySelector('.js-overlay');
      if (overlay) {
        const button = overlay.querySelector('.js-overlay__button');
        button.addEventListener('click', e => {
          e.preventDefault();
          overlay.classList.add('is-closed');
        });
      }
    }
  },
  campaigns: {
    initialize: () => {},
    employee_engagement: () => {},
    digital_transformation: () => {
      const controller = new ScrollMagic.Controller();
      const initialSidePoints = [
        new Point(0, 0),
        new Point(-3, 5),
        new Point(-2.5, 10),
        new Point(-3.5, 15),
        new Point(0, 19)
      ];

      b2bImageMaskAnimation(controller);
      canvasAnimation(
        '.side-blob--with-dot',
        initialSidePoints,
        0.001,
        1.2,
        10,
        10,
        '#433388'
      );

      ['mousemove', 'touchstart', 'touchmove'].forEach(event => {
        if (window.innerWidth > 480) {
          window.addEventListener(
            event,
            e => {
              subtleMouseMove(e, '.js-mousemove');
            },
            false
          );
        }
      });
    },
    data_science: () => {
      videoReplace();
    }
  }
});
